class WishlistConsolidate {
  async consolidateWishlists () {
    try {
      await window.theme.wishlist.readyPromise
      await window.theme.wishlist.wishlistPromise

      const wishlists = await window.theme.wishlist.fetchWishlists()

      if (!wishlists || wishlists.length <= 1) {
        return
      }

      const targetWishlist = wishlists[0]
      const allProducts = await this.collectAllProducts(wishlists)

      if (allProducts.length > 0) {
        const targetWishlistDetails = await window.theme.wishlist.fetchWishlist(targetWishlist.lid)
        const existingProducts = targetWishlistDetails?.items || []

        const newProducts = this.removeDuplicates(allProducts, existingProducts)

        if (newProducts.length > 0) {
          await this.addProductsToWishlist(targetWishlist.lid, newProducts)
        }
      }

      await this.cleanupOtherWishlists(wishlists, targetWishlist.lid)
    } catch (error) {
      console.error('Error during wishlist consolidation:', error)
    }
  }

  async collectAllProducts (wishlists) {
    const allProducts = []

    for (const wishlist of wishlists) {
      try {
        const wishlistDetails = await window.theme.wishlist.fetchWishlist(wishlist.lid)

        if (wishlistDetails?.items && wishlistDetails.items.length > 0) {
          const products = wishlistDetails.items.map(item => ({
            du: item.du,
            empi: item.empi,
            epi: item.epi,
          }))

          allProducts.push(...products)
        }
      } catch (error) {
        console.error(`Error fetching details for wishlist ${wishlist.lid}:`, error)
      }
    }

    return allProducts
  }

  removeDuplicates (allProducts, existingProducts) {
    const existingKeys = new Set(
      existingProducts.map(product => `${product.empi}-${product.epi}`),
    )

    return allProducts.filter(product => {
      const key = `${product.empi}-${product.epi}`
      return !existingKeys.has(key)
    })
  }

  async addProductsToWishlist (lid, products) {
    return new Promise((resolve, reject) => {
      const onSuccess = (response) => {
        resolve(response)
      }

      const onError = (error) => {
        console.error('Error while adding products to wishlist:', error)
        reject(error)
      }

      window._swat.addProductsToList(lid, products, onSuccess, onError)
    })
  }

  async cleanupOtherWishlists (allWishlists, targetWishlistId) {
    const wishlistsToDelete = allWishlists.filter(wishlist => wishlist.lid !== targetWishlistId)

    if (wishlistsToDelete.length === 0) {
      return
    }

    for (const wishlist of wishlistsToDelete) {
      try {
        await this.deleteWishlist(wishlist.lid)
      } catch (error) {
        console.error(`Error deleting wishlist ${wishlist.lid}:`, error)
      }
    }
  }

  async deleteWishlist (lid) {
    return new Promise((resolve, reject) => {
      const onSuccess = (deletedListObj) => {
        resolve(deletedListObj)
      }

      const onError = (error) => {
        reject(error)
      }

      // Use Swym's deleteList method
      window._swat.deleteList(lid, onSuccess, onError)
    })
  }

  static async run () {
    const consolidator = new WishlistConsolidate()
    await consolidator.consolidateWishlists()
  }
}

window.WishlistConsolidate = WishlistConsolidate

document.addEventListener('DOMContentLoaded', () => WishlistConsolidate.run())
